import * as THREE from 'three';
import type { BallState } from './BallState';

export class BallIntegrator {
  static readonly GRAVITY = new THREE.Vector3(0, -9.81, 0);

  integrate(state: BallState, acceleration: THREE.Vector3, deltaSeconds: number): void {
    const totalAcceleration = acceleration.clone().add(BallIntegrator.GRAVITY);
    state.velocity.addScaledVector(totalAcceleration, deltaSeconds);
    state.position.addScaledVector(state.velocity, deltaSeconds);
  }
}
